/**
 * COPYRIGHT NOTICE
 * Copyright (c) 2020 Neue Rituale GbR
 * @author NR <code@neuerituale.com>
 */


import lesson from './Lesson';
import badge from './Badge';

export default {
	lesson, badge
}
